import { getDefaultRedirectPath } from './redirectUtils';

/**
 * Validate login form fields
 * @param {string} email - Email address
 * @param {string} password - Password
 * @returns {Object} Validation result with isValid flag and error message
 */
export const validateLoginForm = (email, password) => {
  if (!email || !password) {
    return {
      isValid: false,
      error: 'Please fill in all fields',
    };
  }

  return {
    isValid: true,
    error: null,
  };
};

/**
 * Get user from localStorage
 * @returns {Object|null} User object or null
 */
export const getUserFromStorage = () => {
  try {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    return null;
  }
};

/**
 * Handle successful login - get user and navigate to default path
 * @param {Object} user - User object
 * @param {Function} navigate - React Router navigate function
 */
export const handleLoginSuccess = (user, navigate) => {
  const redirectPath = getDefaultRedirectPath(user);
  navigate(redirectPath);
};
